// Baut die Routen einer Plattform aus den Modul-Beiträgen (Besitzer: geruest).
import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router';
import { NotFound } from '@web/app/NotFound';
import { RouteError } from '@web/app/RouteError';
import type { LoadedRegistry } from './load';
import type { PlatformKey } from './types';

function withModuleBoundary(route: RouteObject, module: string): RouteObject {
  return {
    ...route,
    errorElement: route.errorElement ?? <RouteError module={module} />,
    handle: { module, ...(route.handle as object | undefined) },
  } as RouteObject;
}

export interface BuildRoutesOptions {
  /** Shell der Plattform (Layout mit <Outlet />), gebaut von ui-basis. */
  Shell: ComponentType;
  /** Eingebaute öffentliche Routen (z. B. /galerie). */
  builtinPublicRoutes?: RouteObject[];
}

export function buildRoutes(
  registry: LoadedRegistry<PlatformKey>,
  { Shell, builtinPublicRoutes = [] }: BuildRoutesOptions,
): RouteObject[] {
  const routes = registry.modules.flatMap(({ key, contribution }) =>
    (contribution.routes ?? []).map((route) => withModuleBoundary(route, key)),
  );
  const publicRoutes = registry.modules.flatMap(({ key, contribution }) =>
    (contribution.publicRoutes ?? []).map((route) => withModuleBoundary(route, key)),
  );
  return [
    {
      errorElement: <RouteError />,
      children: [
        ...builtinPublicRoutes,
        ...publicRoutes,
        { element: <Shell />, children: [...routes, { path: '*', element: <NotFound /> }] },
      ],
    },
  ];
}
